<template>
  <div class="content-wrapper">
    <sub-header :title="$t('menu.cashhero')" />
    <section class="content container-fluid">
      <div class="error-page">
        <h2 class="headline text-yellow">
          401
        </h2>
        <div class="error-content">
          <h3>
            <i class="fa fa-warning text-yellow" /> {{ $t('http.401') }}
          </h3>
          <p>
            The HTTP <strong>401 Unauthorized</strong> client error status response code indicates that the request has
            not
            been applied because it lacks valid authentication credentials for the target resource.
          </p>
          <button
            @click="$router.push({name: 'dashboard'})"
            class="btn btn-primary btn-sm"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SubHeader from '@/components/SubHeader'

export default {
  name: 'Unauthorized',
  components: { SubHeader },
  metaInfo () {
    return {
      title: this.$t('string.unauthorized'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  mounted () {
    this.$isLoading(false)
  }
}
</script>

<style scoped>
</style>
